import React, { useState } from "react";
import * as yup from "yup";
import constant from "../../../utils/constant";
import { CreateLimit } from "../../../pages";
import { MoneyExController } from "../../../controllers";
import { MimaToastUtil } from "../../../components";

const CreateLimitContainer = ({ closeModal, rateModal }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object().shape({
    daily: yup.array().of(
      yup.object().shape({
        currencyCode: yup.string().required("Currency code is required"),
        value: yup
          .number()
          .positive("Value must be positive")
          .required("Value is required"),
      })
    ),
    weekly: yup.array().of(
      yup.object().shape({
        currencyCode: yup.string().required("Currency code is required"),
        value: yup
          .number()
          .positive("Value must be positive")
          .required("Value is required"),
      })
    ),
    monthly: yup.array().of(
      yup.object().shape({
        currencyCode: yup.string().required("Currency code is required"),
        value: yup
          .number()
          .positive("Value must be positive")
          .required("Value is required"),
      })
    ),
  });

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      daily: values.daily,
      weekly: values.weekly,
      monthly: values.monthly,
      grade: values.grade,
    };
    const { status } = await MoneyExController.createLimit(payload);
    if (status === constant.Success) {
      closeModal();
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
    }
    setLoading(false);
    return closeModal();
  };

  const currencyCodes = [
    {
      key: "NGN",
      value: "NGN",
    },
    {
      key: "USD",
      value: "USD",
    },
    {
      key: "GBP",
      value: "GBP",
    },
    {
      key: "EUR",
      value: "EUR",
    },
  ];
  return (
    <CreateLimit
      rateModal={rateModal}
      loading={loading}
      currencyCodes={currencyCodes}
      closeModal={closeModal}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    />
  );
};
export default CreateLimitContainer;
